import * as api from '../../api';
import { invalidateCurrentSession } from '../auth.actions'

export const sendHeartbeatActions = api.fetchActions('heartbeat', 'send-heartbeat');

export const actionTypes = {
  ...sendHeartbeatActions.actionTypes,
};

export function sendHeartbeat() {
  return (dispatch) => {
    const apiConfig = {
      unauthorizedPostNotifier: () => dispatch(invalidateCurrentSession()),
    };
    return dispatch(api.postThunk('/sessions/keepalive', null, sendHeartbeatActions, null, apiConfig))
  }
}



// WEBPACK FOOTER //
// src/auth/heartbeat-system/heartbeat.actions.js